module.exports = AMap;